import React from 'react';
import { Link } from 'react-router-dom';
import '../styles/AdminLayout.css';
import '../styles/AdminNews.css';

const cards = [
    {
        to: '/admin/news',
        title: 'Notícias',
        icon: 'ri-newspaper-line',
        description: 'Criar e editar posts, anúncios, eventos e patch notes exibidos na home e na página de notícias.',
    },
    {
        to: '/admin/guides',
        title: 'Guias do jogo',
        icon: 'ri-book-open-line',
        description: 'Categorias e tutoriais exibidos em /game — textos em inglês e português.',
    },
    {
        to: '/admin/mount-guide',
        title: 'Guia de montarias',
        icon: 'ri-dragon-line',
        description: 'Regiões, raridades e fichas de familiares em /game/montarias.',
    },
    {
        to: '/admin/downloads',
        title: 'Downloads',
        icon: 'ri-download-cloud-line',
        description: 'Textos da página e links dos botões de download exibidos em /download.',
    },
    {
        to: '/admin/event-packages',
        title: 'Pacotes de evento',
        icon: 'ri-gift-2-line',
        description: 'Pacotes de evento, itens entregues no Elora Storage e códigos promocionais (1 resgate por conta).',
    },
    {
        to: '/admin/streamers',
        title: 'Streamers / Lives',
        icon: 'ri-live-line',
        description: 'Marque contas como streamer e defina os links de transmissão exibidos na página de Lives (/live).',
    },
    {
        to: '/admin/settings/general',
        title: 'Site e aparência',
        icon: 'ri-settings-3-line',
        description: 'Nome do site, hero da home, menu, logo, cores, Discord e textos dos cards.',
    },
    {
        to: '/admin/settings/links',
        title: 'Links e Discord',
        icon: 'ri-links-line',
        description: 'Convite do Discord e link de suporte exibidos no footer e em outras áreas.',
    },
    {
        to: '/admin/settings/navbar',
        title: 'Navbar e menu',
        icon: 'ri-menu-line',
        description: 'Logo, posição e itens do menu de navegação do site.',
    },
    {
        to: '/admin/settings/home',
        title: 'Home e cards',
        icon: 'ri-home-4-line',
        description: 'Textos do hero e os 8 cards de features da página inicial.',
    },
    {
        to: '/admin/settings/download',
        title: 'Página de download',
        icon: 'ri-file-text-line',
        description: 'Textos da página /download em inglês e português.',
    },
    {
        to: '/admin/settings/theme',
        title: 'Cores e tema',
        icon: 'ri-palette-line',
        description: 'Paleta de cores, efeitos visuais e temas salvos para recuperar depois.',
    },
    {
        to: '/admin/settings/guildRank',
        title: 'Cards de guild',
        icon: 'ri-shield-line',
        description: 'Edite ao vivo a posição, o tamanho e a cor dos elementos do card de guild no ranking.',
    },
];

const AdminDashboard: React.FC = () => {
    return (
        <div className="admin-page">
            <header className="admin-page-header">
                <h1 className="admin-page-title">Painel de administração</h1>
                <p className="admin-page-subtitle">
                    Gerencie notícias, links de download, textos da home, menu, cores e informações do site.
                </p>
            </header>

            <div className="admin-cards-grid">
                {cards.map((card) => (
                    <Link key={card.to} to={card.to} className="admin-category-card">
                        <div className="admin-category-card-icon">
                            <i className={card.icon} aria-hidden />
                        </div>
                        <h2>{card.title}</h2>
                        <p>{card.description}</p>
                    </Link>
                ))}
            </div>
        </div>
    );
};

export default AdminDashboard;
